exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".direction-input[data-v-4767b56f]{direction:ltr}.direction-label[data-v-4767b56f]{text-align:left}", ""]);

// exports
